/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Page_TitleInputs */

const fr_legal_page_title = /** @type {(inputs: Legal_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions légales – Bus Tracker`)
};

const en_legal_page_title = /** @type {(inputs: Legal_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal notice – Bus Tracker`)
};

/**
* | output |
* | --- |
* | "Legal notice – Bus Tracker" |
*
* @param {Legal_Page_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_page_title = /** @type {((inputs?: Legal_Page_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Page_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_page_title(inputs)
	return en_legal_page_title(inputs)
});